import { render, staticRenderFns } from "./LazyLoad.vue?vue&type=template&id=6650877c&"
import script from "./LazyLoad.vue?vue&type=script&lang=js&"
export * from "./LazyLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uweschurmann/PhpstormProjects/1165/16/HandtuchShop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6650877c')) {
      api.createRecord('6650877c', component.options)
    } else {
      api.reload('6650877c', component.options)
    }
    module.hot.accept("./LazyLoad.vue?vue&type=template&id=6650877c&", function () {
      api.rerender('6650877c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/common/LazyLoad.vue"
export default component.exports